import React from 'react';

import VolunteersPage from '../components/VolunteersPage';

const VolunteersApp = (props) => (
  <VolunteersPage {...props} />
);

export default VolunteersApp;